/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateLandlordPartnerRequestDto,
  CreateLandlordPartnerResponseDto,
  CreateOemPartnerRequestDto,
  CreateOemPartnerResponseDto,
  ListLandlordsResponseDto,
  ListOemsResponseDto,
  ListPartnerMaintenanceRulesResponseDto,
  PartnerMaintenanceRulesResponseDto,
  PartnerMaintenanceScopeOptionsResponseDto,
  PartnerSearchResultDto,
  ReplacePartnerMaintenanceRulesRequestDto,
  UpdateLandlordSlaRequestDto,
  UpdateLandlordSlaResponseDto,
  UpdateOemContractRequestDto,
  UpdateOemContractResponseDto,
} from '../models/index';
import {
    CreateLandlordPartnerRequestDtoFromJSON,
    CreateLandlordPartnerRequestDtoToJSON,
    CreateLandlordPartnerResponseDtoFromJSON,
    CreateLandlordPartnerResponseDtoToJSON,
    CreateOemPartnerRequestDtoFromJSON,
    CreateOemPartnerRequestDtoToJSON,
    CreateOemPartnerResponseDtoFromJSON,
    CreateOemPartnerResponseDtoToJSON,
    ListLandlordsResponseDtoFromJSON,
    ListLandlordsResponseDtoToJSON,
    ListOemsResponseDtoFromJSON,
    ListOemsResponseDtoToJSON,
    ListPartnerMaintenanceRulesResponseDtoFromJSON,
    ListPartnerMaintenanceRulesResponseDtoToJSON,
    PartnerMaintenanceRulesResponseDtoFromJSON,
    PartnerMaintenanceRulesResponseDtoToJSON,
    PartnerMaintenanceScopeOptionsResponseDtoFromJSON,
    PartnerMaintenanceScopeOptionsResponseDtoToJSON,
    PartnerSearchResultDtoFromJSON,
    PartnerSearchResultDtoToJSON,
    ReplacePartnerMaintenanceRulesRequestDtoFromJSON,
    ReplacePartnerMaintenanceRulesRequestDtoToJSON,
    UpdateLandlordSlaRequestDtoFromJSON,
    UpdateLandlordSlaRequestDtoToJSON,
    UpdateLandlordSlaResponseDtoFromJSON,
    UpdateLandlordSlaResponseDtoToJSON,
    UpdateOemContractRequestDtoFromJSON,
    UpdateOemContractRequestDtoToJSON,
    UpdateOemContractResponseDtoFromJSON,
    UpdateOemContractResponseDtoToJSON,
} from '../models/index';

export interface PartnersControllerCreateLandlordRequest {
    organizationId: string;
    createLandlordPartnerRequestDto: CreateLandlordPartnerRequestDto;
}

export interface PartnersControllerCreateOemRequest {
    organizationId: string;
    createOemPartnerRequestDto: CreateOemPartnerRequestDto;
}

export interface PartnersControllerListLandlordsRequest {
    organizationId: string;
}

export interface PartnersControllerListOemsRequest {
    organizationId: string;
}

export interface PartnersControllerListPartnerMaintenanceRulesRequest {
    organizationId: string;
}

export interface PartnersControllerListPartnerMaintenanceScopeOptionsRequest {
    organizationId: string;
}

export interface PartnersControllerReplacePartnerMaintenanceRulesRequest {
    relationshipId: string;
    organizationId: string;
    replacePartnerMaintenanceRulesRequestDto: ReplacePartnerMaintenanceRulesRequestDto;
}

export interface PartnersControllerSearchPartnersRequest {
    organizationId: string;
}

export interface PartnersControllerUpdateLandlordRequest {
    relationshipId: string;
    organizationId: string;
    updateLandlordSlaRequestDto: UpdateLandlordSlaRequestDto;
}

export interface PartnersControllerUpdateOemRequest {
    relationshipId: string;
    organizationId: string;
    updateOemContractRequestDto: UpdateOemContractRequestDto;
}

/**
 * 
 */
export class PartnersApi extends runtime.BaseAPI {

    /**
     */
    async partnersControllerCreateLandlordRaw(requestParameters: PartnersControllerCreateLandlordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLandlordPartnerResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerCreateLandlord().'
            );
        }

        if (requestParameters['createLandlordPartnerRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createLandlordPartnerRequestDto',
                'Required parameter "createLandlordPartnerRequestDto" was null or undefined when calling partnersControllerCreateLandlord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/landlords`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLandlordPartnerRequestDtoToJSON(requestParameters['createLandlordPartnerRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLandlordPartnerResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerCreateLandlord(requestParameters: PartnersControllerCreateLandlordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLandlordPartnerResponseDto> {
        const response = await this.partnersControllerCreateLandlordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerCreateOemRaw(requestParameters: PartnersControllerCreateOemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOemPartnerResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerCreateOem().'
            );
        }

        if (requestParameters['createOemPartnerRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createOemPartnerRequestDto',
                'Required parameter "createOemPartnerRequestDto" was null or undefined when calling partnersControllerCreateOem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/oems`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOemPartnerRequestDtoToJSON(requestParameters['createOemPartnerRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOemPartnerResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerCreateOem(requestParameters: PartnersControllerCreateOemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOemPartnerResponseDto> {
        const response = await this.partnersControllerCreateOemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerListLandlordsRaw(requestParameters: PartnersControllerListLandlordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListLandlordsResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerListLandlords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/landlords`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListLandlordsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerListLandlords(requestParameters: PartnersControllerListLandlordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListLandlordsResponseDto> {
        const response = await this.partnersControllerListLandlordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerListOemsRaw(requestParameters: PartnersControllerListOemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOemsResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerListOems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/oems`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOemsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerListOems(requestParameters: PartnersControllerListOemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOemsResponseDto> {
        const response = await this.partnersControllerListOemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerListPartnerMaintenanceRulesRaw(requestParameters: PartnersControllerListPartnerMaintenanceRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPartnerMaintenanceRulesResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerListPartnerMaintenanceRules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/oems/maintenance-rules`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPartnerMaintenanceRulesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerListPartnerMaintenanceRules(requestParameters: PartnersControllerListPartnerMaintenanceRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPartnerMaintenanceRulesResponseDto> {
        const response = await this.partnersControllerListPartnerMaintenanceRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerListPartnerMaintenanceScopeOptionsRaw(requestParameters: PartnersControllerListPartnerMaintenanceScopeOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerMaintenanceScopeOptionsResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerListPartnerMaintenanceScopeOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/oems/maintenance-rules/scope-options`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerMaintenanceScopeOptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerListPartnerMaintenanceScopeOptions(requestParameters: PartnersControllerListPartnerMaintenanceScopeOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerMaintenanceScopeOptionsResponseDto> {
        const response = await this.partnersControllerListPartnerMaintenanceScopeOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerReplacePartnerMaintenanceRulesRaw(requestParameters: PartnersControllerReplacePartnerMaintenanceRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerMaintenanceRulesResponseDto>> {
        if (requestParameters['relationshipId'] == null) {
            throw new runtime.RequiredError(
                'relationshipId',
                'Required parameter "relationshipId" was null or undefined when calling partnersControllerReplacePartnerMaintenanceRules().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerReplacePartnerMaintenanceRules().'
            );
        }

        if (requestParameters['replacePartnerMaintenanceRulesRequestDto'] == null) {
            throw new runtime.RequiredError(
                'replacePartnerMaintenanceRulesRequestDto',
                'Required parameter "replacePartnerMaintenanceRulesRequestDto" was null or undefined when calling partnersControllerReplacePartnerMaintenanceRules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/oems/{relationshipId}/maintenance-rules`;
        urlPath = urlPath.replace(`{${"relationshipId"}}`, encodeURIComponent(String(requestParameters['relationshipId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplacePartnerMaintenanceRulesRequestDtoToJSON(requestParameters['replacePartnerMaintenanceRulesRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerMaintenanceRulesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerReplacePartnerMaintenanceRules(requestParameters: PartnersControllerReplacePartnerMaintenanceRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerMaintenanceRulesResponseDto> {
        const response = await this.partnersControllerReplacePartnerMaintenanceRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerSearchPartnersRaw(requestParameters: PartnersControllerSearchPartnersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerSearchResultDto>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerSearchPartners().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/search`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerSearchResultDtoFromJSON));
    }

    /**
     */
    async partnersControllerSearchPartners(requestParameters: PartnersControllerSearchPartnersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerSearchResultDto>> {
        const response = await this.partnersControllerSearchPartnersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerUpdateLandlordRaw(requestParameters: PartnersControllerUpdateLandlordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLandlordSlaResponseDto>> {
        if (requestParameters['relationshipId'] == null) {
            throw new runtime.RequiredError(
                'relationshipId',
                'Required parameter "relationshipId" was null or undefined when calling partnersControllerUpdateLandlord().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerUpdateLandlord().'
            );
        }

        if (requestParameters['updateLandlordSlaRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateLandlordSlaRequestDto',
                'Required parameter "updateLandlordSlaRequestDto" was null or undefined when calling partnersControllerUpdateLandlord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/landlords/{relationshipId}`;
        urlPath = urlPath.replace(`{${"relationshipId"}}`, encodeURIComponent(String(requestParameters['relationshipId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLandlordSlaRequestDtoToJSON(requestParameters['updateLandlordSlaRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLandlordSlaResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerUpdateLandlord(requestParameters: PartnersControllerUpdateLandlordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLandlordSlaResponseDto> {
        const response = await this.partnersControllerUpdateLandlordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partnersControllerUpdateOemRaw(requestParameters: PartnersControllerUpdateOemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateOemContractResponseDto>> {
        if (requestParameters['relationshipId'] == null) {
            throw new runtime.RequiredError(
                'relationshipId',
                'Required parameter "relationshipId" was null or undefined when calling partnersControllerUpdateOem().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling partnersControllerUpdateOem().'
            );
        }

        if (requestParameters['updateOemContractRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateOemContractRequestDto',
                'Required parameter "updateOemContractRequestDto" was null or undefined when calling partnersControllerUpdateOem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/partners/oems/{relationshipId}`;
        urlPath = urlPath.replace(`{${"relationshipId"}}`, encodeURIComponent(String(requestParameters['relationshipId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOemContractRequestDtoToJSON(requestParameters['updateOemContractRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateOemContractResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partnersControllerUpdateOem(requestParameters: PartnersControllerUpdateOemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateOemContractResponseDto> {
        const response = await this.partnersControllerUpdateOemRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
